import React from 'react';
import styles from '../FileSelect.module.css';
import { IoClose, IoPlay, IoSave } from 'react-icons/io5';
import classNames from 'classnames';

export default function SelectedFileControl({ file, progress, onClear, onPlay, onSave }) {
  if (file)
    return (
      <div className="flex-fill align-self-stretch d-flex flex-column justify-content-center align-items-stretch px-5">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="text-truncate small fw-semibold">{file.name}</span>
          <button className="btn btn-sm btn-outline-secondary ms-2 flex-shrink-0" onClick={onClear}>
            <IoClose size={16} />
          </button>
        </div>

        <div className="progress mb-1" style={{ height: 16 }}>
          <div
            className="progress-bar bg-success"
            style={{ width: `${progress * 100}%`, fontSize: '0.75rem' }}
          >
            {Math.round(progress * 100)}%
          </div>
        </div>

        <p className="text-center small text-muted mb-3">{(file.size / 1000000).toFixed(2)} MB</p>

        <div className="d-flex justify-content-center gap-2">
          {onSave && (
            <button className="btn btn-sm btn-primary" onClick={onSave}>
              <IoSave className="me-1" />
              Save to list
            </button>
          )}

          {onPlay && (
            <button className="btn btn-sm btn-primary" onClick={onPlay}>
              <IoPlay className="me-1" />
              Play now
            </button>
          )}
        </div>
      </div>
    );
}
